class Decrypt{
    constructor($el){
        this.$el = $el;
        this.$encryptedEmail = $el.data('encryptedEmail');
        this.init();
    }

    init = () =>{
        const $decrypedEmail = atob(this.$encryptedEmail);

        this.$el.attr('href', 'mailto:' + $decrypedEmail);
        this.$el.attr('aria-hidden', 'false');
    }
}

export default Decrypt;